import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "dsa-token dsa-token--ok",
  role: "note"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BreadCrumb = _resolveComponent("BreadCrumb")!
  const _component_DriverStatusApiDocs = _resolveComponent("DriverStatusApiDocs")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_BreadCrumb, { PageTitle: "Documentation API – Changement de statut" }),
    _createVNode(_component_DriverStatusApiDocs, null, {
      intro: _withCtx(() => [
        (_ctx.access && _ctx.access.driver_code)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _cache[4] || (_cache[4] = _createElementVNode("i", {
                class: "ph ph-key",
                "aria-hidden": "true"
              }, null, -1)),
              _createElementVNode("span", null, [
                _cache[0] || (_cache[0] = _createTextVNode("Votre ", -1)),
                _cache[1] || (_cache[1] = _createElementVNode("code", null, "driver-code", -1)),
                _cache[2] || (_cache[2] = _createTextVNode(" est ", -1)),
                _createElementVNode("code", null, _toDisplayString(_ctx.access.driver_code), 1),
                _cache[3] || (_cache[3] = _createTextVNode(" (le même que chez Kargo).", -1))
              ])
            ]))
          : _createCommentVNode("", true),
        (_ctx.access)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(["dsa-token", _ctx.access.has_token ? 'dsa-token--ok' : 'dsa-token--none']),
              role: "note"
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(_ctx.access.has_token ? 'ph ph-key' : 'ph ph-info'),
                "aria-hidden": "true"
              }, null, 2),
              (_ctx.access.has_token)
                ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
                    _cache[5] || (_cache[5] = _createTextVNode(" Votre token JSON (format natif) est actif (", -1)),
                    _createElementVNode("code", null, "sdl_••••" + _toDisplayString(_ctx.access.token_hint), 1),
                    _createTextVNode(", créé le " + _toDisplayString(_ctx.formatDate(_ctx.access.token_created_at)), 1),
                    (_ctx.access.last_used_at)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(", dernière utilisation le " + _toDisplayString(_ctx.formatDate(_ctx.access.last_used_at)), 1)
                        ], 64))
                      : _createCommentVNode("", true),
                    _cache[6] || (_cache[6] = _createTextVNode("). Il n'est jamais réaffiché : en cas de perte, demandez-en un nouveau à l'administrateur. ", -1))
                  ]))
                : (_openBlock(), _createElementBlock("span", _hoisted_3, "Aucun token JSON n'a été généré pour votre compte (inutile pour le format Kargo)."))
            ], 2))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ], 64))
}